import { axios } from "../axiosInstance";
import type {
  IOfficeMainContact,
  IOfficeMainContactWrite,
} from "../interfaces/models/IOfficeMainContact";

export function asOfficeMainContactList(data: unknown): IOfficeMainContact[] {
  if (data == null) {
    return [];
  }
  return Array.isArray(data)
    ? (data as IOfficeMainContact[])
    : [data as IOfficeMainContact];
}

export const getOfficeMainContactsByFirmId = async (
  firmId: string,
): Promise<IOfficeMainContact[]> => {
  const params = new URLSearchParams();
  params.append(
    "filter",
    JSON.stringify({
      firmId: { value: firmId.trim(), comparisonType: "EQUAL" },
    }),
  );
  const response = await axios.Get(`./officeMainContact?${params.toString()}`);
  return asOfficeMainContactList(response.data);
};

export const createOfficeMainContact = async (
  payload: IOfficeMainContactWrite,
): Promise<unknown> => {
  const response = await axios.Post("/officeMainContact", payload);
  return response.data;
};

export const updateOfficeMainContact = async (
  payload: IOfficeMainContactWrite,
): Promise<unknown> => {
  const response = await axios.PutDataIntoModel("/officeMainContact", payload);
  return response.data;
};

export const saveOfficeMainContact = async (
  payload: IOfficeMainContactWrite,
): Promise<unknown> => {
  if (String(payload.id ?? "").trim()) {
    return updateOfficeMainContact(payload);
  }
  return createOfficeMainContact(payload);
};

export const deleteOfficeMainContact = async (
  id: string,
  officeId?: string,
): Promise<boolean> => {
  const params = new URLSearchParams();
  params.append("id", id);
  if (officeId?.trim()) {
    params.append("officeId", officeId.trim());
  }
  const response = await axios.Delete(
    `/officeMainContact?${params.toString()}`,
    "",
  );
  return response.status === 200;
};
